import dayjs from 'dayjs';

/** Beyond this many days a relative label stops being useful; show the date. */
const MAX_DAYS_FOR_RELATIVE_LABEL = 14;
const ABSOLUTE_DATE_FORMAT = 'D MMM';

/**
 * Human-readable "Updated ..." label for an FPL availability note, e.g.
 * "Updated today", "Updated 3 days ago" or "Updated 15 Aug". Null when the
 * timestamp is missing or unparseable, so the caller can drop the label.
 */
export const formatNewsUpdatedLabel = (
  newsAddedAt: string | null | undefined,
  now: Date = new Date()
): string | null => {
  if (!newsAddedAt) return null;

  const added = dayjs(newsAddedAt);
  if (!added.isValid()) return null;

  const daysAgo = dayjs(now).startOf('day').diff(added.startOf('day'), 'day');

  if (daysAgo <= 0) return 'Updated today';
  if (daysAgo === 1) return 'Updated yesterday';
  if (daysAgo <= MAX_DAYS_FOR_RELATIVE_LABEL)
    return `Updated ${daysAgo} days ago`;

  return `Updated ${added.format(ABSOLUTE_DATE_FORMAT)}`;
};
